import { TEXT } from '../../../../helpers';

export const FileUploaderConst = {
	emailAttachmentWarning: TEXT.emailAttachmentWarning,
	warning: TEXT.warning,
};
